"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTickValuesInclusive = exports.computeGapsInSeriesData = void 0;

var _d = _interopRequireDefault(require("../../lib/d3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateTickValuesInclusive = function generateTickValuesInclusive(_ref) {
  var scale = _ref.scale,
      _ref$tickSeparation = _ref.tickSeparation,
      tickSeparation = _ref$tickSeparation === void 0 ? 120 : _ref$tickSeparation,
      _ref$minTickThreshold = _ref.minTickThreshold,
      minTickThreshold = _ref$minTickThreshold === void 0 ? 120 : _ref$minTickThreshold,
      _ref$valueAccessor = _ref.valueAccessor,
      valueAccessor = _ref$valueAccessor === void 0 ? function (v) {
    return v;
  } : _ref$valueAccessor;
  var min = scale.domain()[0];
  var max = scale.domain()[1];

  var tickValues = _d.default.ticks(min, max, Math.abs(Math.round((scale(max) - scale(min)) / tickSeparation)));

  tickValues.unshift(min);
  tickValues.push(max); // if second value is too close to the first value, drop it

  if (Math.abs(scale(tickValues[1]) - scale(tickValues[0])) < minTickThreshold) {
    tickValues.splice(1, 1);
  } // if second to last point is too close to the end point, drop it


  if (Math.abs(scale(tickValues[tickValues.length - 1]) - scale(tickValues[tickValues.length - 2])) < minTickThreshold) {
    tickValues.splice(tickValues.length - 2, 1);
  } // force zero if not included


  if (min < 0 && max > 0 && tickValues.indexOf(0) === -1) {
    tickValues.push(0);
  }

  tickValues = tickValues.map(valueAccessor).sort(function (a, b) {
    if (a instanceof Date) {
      a = a.getTime();
    }

    if (b instanceof Date) {
      b = b.getTime();
    }

    return a - b;
  });
  return tickValues;
};

exports.generateTickValuesInclusive = generateTickValuesInclusive;

var computeGapsInSeriesData = function computeGapsInSeriesData(_ref2) {
  var data = _ref2.data,
      threshold = _ref2.threshold,
      _ref2$xAccessor = _ref2.xAccessor,
      xAccessor = _ref2$xAccessor === void 0 ? function (d) {
    return d[0];
  } : _ref2$xAccessor;
  var splitIndeces = [0];

  if (threshold) {
    data.forEach(function (d, i) {
      var next = data[i + 1];

      if (next && i < data.length - 1) {
        if (Math.abs(xAccessor(d) - xAccessor(next)) > threshold) {
          splitIndeces.push(i + 1);
        }
      }
    });
  }

  return splitIndeces.reduce(function (acc, v, i) {
    var endIndex = splitIndeces[i + 1] || data.length;
    return acc.concat([data.slice(v, endIndex)]);
  }, []);
};

exports.computeGapsInSeriesData = computeGapsInSeriesData;